<template>
<div @mouseover="!isMobile ? hovered = true : null" @mouseleave="!isMobile ? hovered = false : null" class="element-with-credit">
  <div class="non-lb-asset">
    <slot></slot>
  </div>
  <div :class="['credit-hover', hovered ? 'active' : '']">
    <span v-html="credit"></span>
  </div>
</div>
</template>

<script>
export default {
  name: 'elementWithCredit',
  data() {
    return {
      hovered: false,
    }
  },
  props: {
    credit: {
      type: String,
      default: ''
    },
  },
  computed: {
    isMobile() {
      return this.$root.isMobile
    }
  },
  mounted() {
    if (this.isMobile) {
      this.hovered = true
    }
  },
  methods: {
    handleHover() {
      if (!this.isMobile) {
        this.hovered = !this.hovered;
      }
    }
  },
}
</script>

<style lang="scss">
.element-with-credit {
    position: relative;
    &:hover .non-lb-asset {
        border-radius: 0;
        border-color: black;
        img,
        video {
            border-radius: 0;

        }
    }
}
.credit-hover {
    text-align: center;
    width: 100%;
    color: $red;
    opacity: 0;
    transition: 0.3s opacity ease;
    position: absolute;
    bottom: 0.8rem;
    a {
        border-bottom: 1px solid $red;
    }
    &.active {
        opacity: 1;

    }
}
.non-lb-asset {
    border: 2px solid $red;
    padding: 2rem;
    margin: 2rem;
    border-radius: 2rem;
    width: calc(100% - 4rem);
    transition: 0.3s border-radius ease, 0.3s border-color ease;
    position: relative;
    img,
    video {
        border-radius: 1rem;
        transition: 0.3s border-radius ease;

    }

}
@media screen and (max-width: 600px) {
    .credit-hover {
        font-size: 1.2rem;
    }
}
</style>
